import { createAction, props } from '@ngrx/store';
import { IRoleOptionsState } from './role-options.state';

export const loadRoleOptions = createAction('[RoleOptions] Load Role Options');

export const loadRoleOptionsSuccess = createAction(
  '[RoleOptions] Load Role Options Success',
  props<Partial<IRoleOptionsState>>()
);
